type Props = {
    value: string;
    sending: boolean;
    disabled?: boolean;
    error: string | null;
    onChange: (value: string) => void;
    onSend: () => void;
};

const MentorMessagesComposer = ({ value, sending, disabled, error, onChange, onSend }: Props) => {
    const cannotSend = disabled || sending || !value.trim();
    return (
        <div className="p-3 border-top bg-white">
            {error ? <p className="mmmsg-error">{error}</p> : null}
            <div className="d-flex gap-2 align-items-end">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Write a message"
                    value={value}
                    disabled={disabled || sending}
                    onChange={(event) => onChange(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            if (!cannotSend) onSend();
                        }
                    }}
                />
                <button type="button" className="btn btn-primary d-flex align-items-center justify-content-center flex-shrink-0" disabled={cannotSend} onClick={onSend}>
                    {sending ? 'Sending…' : '➤'}
                </button>
            </div>
        </div>
    );
};

export default MentorMessagesComposer;
